import * as React from "react"
import { VariantProps, cva } from "cva"
import { clx } from "../utils/clx"

const hintVariants = cva({
  base: "txt-small-regular inline-flex items-center gap-x-2",
  variants: {
    variant: {
      info: "text-ui-fg-subtle",
      error: "text-red-base",
    },
  },
  defaultVariants: {
    variant: "info",
  },
})

interface HintProps
  extends VariantProps<typeof hintVariants>,
    React.ComponentPropsWithoutRef<"span"> {}

const Hint = React.forwardRef<HTMLSpanElement, HintProps>(
  (
    {
      className,
      /**
       * The hint's style.
       */
      variant = "info",
      children,
      ...props
    }: HintProps,
    ref
  ) => {
    return (
      <span
        ref={ref}
        className={clx(hintVariants({ variant }), className)}
        {...props}
      >
        {children}
      </span>
    )
  }
)
Hint.displayName = "Hint"

export { Hint }
